import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCbsaLocationQuickInfo extends Layout {
    labelAddress1: Label;
    labelAddress2: Label;
    labelId: Label;
    labelLocationName: Label;
    panelCbsaLocation: Panel;
    sourceLocation: DataSource;
    textboxCbsaPortId: Textbox;
}
